export default "__VITE_PUBLIC_ASSET__50fb88d0__"